<template>
  <div class="basket-product-excludes grid gap-1">
    <div 
      v-for="exclude in excludes" 
      :key="exclude.name"
      class="basket-product-excludes__item flex gap-3 items-center"
    >
      <span class="basket-product-excludes__prefix text-xs text-gray-500">Без</span>
      <div class="basket-product-excludes__name text-sm">
        {{ exclude.name }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface ExcludeDisplay {
  name: string
}

interface Props {
  excludes: ExcludeDisplay[]
}

defineProps<Props>()
</script>

<style scoped lang="scss">
.basket-product-excludes {

  &__item {
    @apply flex items-center;
  }
  
  &__prefix {
    @apply mr-1 text-gray-400 text-xs;
  }
  
  &__name {
    @apply text-sm text-gray-700 dark:text-gray-300;
  }
}
</style>